'use client'

import { useSyncExternalStore } from 'react'
import { THEME_CHANGE_EVENT } from '@/app/components/ThemeProvider'

const STORAGE_KEY = 'pm-theme'
const listeners = new Set()

function systemTheme() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

function getTheme() {
  if (typeof document === 'undefined') return 'light'
  return document.documentElement.getAttribute('data-theme') || systemTheme()
}

function subscribe(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

function emit() {
  listeners.forEach((listener) => listener())
}

export default function ThemeToggle() {
  // The layout init script sets data-theme before hydration. useSyncExternalStore
  // reads the DOM only after hydration, so the server and client renders match
  // (no hydration mismatch) while the correct icon still shows without a flash.
  const theme = useSyncExternalStore(subscribe, getTheme, () => 'light')

  function toggle() {
    const next = theme === 'dark' ? 'light' : 'dark'
    document.documentElement.setAttribute('data-theme', next)
    localStorage.setItem(STORAGE_KEY, next)
    emit()
    window.dispatchEvent(new CustomEvent(THEME_CHANGE_EVENT))
  }

  const label = theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'
  return (
    <button
      type="button"
      onClick={toggle}
      className="theme-toggle"
      aria-label={label}
      title={label}
      data-qa="theme-toggle"
    >
      {theme === 'dark' ? '☀️' : '🌙'}
    </button>
  )
}
